import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Collapse from "@material-ui/core/Collapse";

const useStyles = makeStyles((theme) => ({
  tableCell: {
    padding: "0px !important",
    backgroundColor: theme.palette.grey[100],
  },
  notExpanded: { height: "0px !important", border: "none !important" },
  container: {
    display: "flex",
    justifyContent: "center",
  },
  content: {
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid #E0E0E0`,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(2),
    width: `calc(100% - ${theme.spacing(6)}px)`,
    minHeight: theme.spacing(10),
    backgroundColor: "white",
  },
}));

export default function ExpandTableRow(props) {
  const classes = useStyles();
  const { numberOfColumns, expanded } = props;
  return (
    <TableRow>
      <TableCell
        colSpan={numberOfColumns}
        className={classes.tableCell + " " + (!expanded && classes.notExpanded)}
      >
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <div className={classes.container}>
            <div className={classes.content}>{props.children}</div>
          </div>
        </Collapse>
      </TableCell>
    </TableRow>
  );
}
